import 'virtual:windi-base.css';
import 'virtual:windi-components.css';
import '/@/design/index.less';
import 'virtual:windi-utilities.css';
import 'virtual:svg-icons-register';
import App from './App.vue';
import { createApp } from 'vue';
import { initAppConfigStore } from '/@/logics/initAppConfig';
import { setupErrorHandle } from '/@/logics/error-handle';
import { router, setupRouter } from '/@/router';
import { setupRouterGuard } from '/@/router/guard';
import { setupStore } from '/@/store';
import { setupGlobDirectives } from '/@/directives';
import { setupI18n } from '/@/locales/setupI18n';
import { registerGlobComp } from '/@/components/registerGlobComp';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// import { setupAmap } from '/@/utils/AmapInit';
import { setupStomp } from '/@/utils/wx/tkSetupStomp';
import { initSpeech } from '/@/hooks/nurse/useSpeech';
import { setupAutoRefresh } from '/@/logics/autoRefresh';
import { setupChunkErrorHandler } from '/@/logics/autoRefresh/chunkErrorHandler';
import { useGlobSetting } from '/@/hooks/setting';
const globSetting = useGlobSetting();
const sockUrl = [globSetting.apiUrl + '/websocketStomp', '/wechat/api/websocketStomp'];
async function bootstrap() {
  const app = createApp(App);
  app.use(Antd);
  // app.use(VueRx);
  // Configure store
  // 配置 store
  setupStore(app);

  // Initialize internal system configuration
  // 初始化内部系统配置
  initAppConfigStore();

  // Register global components
  // 注册全局组件
  registerGlobComp(app);

  // Multilingual configuration
  // 多语言配置
  // Asynchronous case: language files may be obtained from the server side
  // 异步案例：语言文件可能从服务器端获取
  await setupI18n(app);

  // Configure routing
  // 配置路由
  setupRouter(app);

  // router-guard
  // 路由守卫
  setupRouterGuard(router);

  // 部署后无感刷新 + chunk 加载失败兜底（必须在 router.isReady() 之前注册：
  // 首屏进入懒路由时就会触发 chunk 加载，注册晚了会漏掉那一次）
  setupAutoRefresh(router);
  setupChunkErrorHandler(router);

  // Register global directive
  // 注册全局指令
  setupGlobDirectives(app);

  // Configure global error handling
  // 配置全局错误处理
  setupErrorHandle(app);

  setupStomp(app, sockUrl);

  initSpeech();

  // https://next.router.vuejs.org/api/#isready
  await router.isReady();
  // await setupAmap(app);

  // tkSetupStomp(app);
  app.mount('#app');
}

void bootstrap();
